import { isDefined } from '@sgme/fp';
import { join, startCase, words } from 'lodash-es';

export const capitalizeFirstletter = (word: string): string => {
  const wordToLowerCase = word.toLowerCase();

  return wordToLowerCase.charAt(0).toUpperCase() + wordToLowerCase.slice(1);
};

export const capitalizeFirstLetterOnly = <T extends string>(word: T): Capitalize<T> => {
  return (word.charAt(0).toUpperCase() + word.slice(1)) as Capitalize<T>;
};

export const camelCaseToWords = (str: string | null | undefined) => {
  if (!isDefined(str)) {
    return '';
  }
  if (!Number.isNaN(parseFloat(str))) {
    return str;
  }
  return join(
    words(startCase(str)).map((x, idx) => (idx === 0 ? x : x.toLocaleLowerCase())),
    ' ',
  );
};

export const pascalCaseToWords = (str: string) => {
  if (!isDefined(str)) {
    return str;
  }
  return join(
    words(startCase(str)).map(x => x),
    ' ',
  );
};

export const snakeCaseToWords = (str: string) => {
  if (!isDefined(str)) {
    return str;
  }

  const whiteSpacedWords = startCase(str);

  const [first, ...remainingWords] = words(whiteSpacedWords);
  const lowerCaseRemainingWords = remainingWords.map(word => word.toLocaleLowerCase());

  return join([first, ...lowerCaseRemainingWords], ' ');
};

export const isNonEmptyAfterTrim = (str?: string) => isDefined(str) && str.trim().length > 0;

export const isUuid = (str: string) =>
  new RegExp(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/).test(str);

export const isQuoteId = isUuid;

export const isExternalQuoteId = (str: string) => new RegExp(/^[A-Z]{3,}-[0-9]{11,}$/).test(str);

export const isPricerId = (str: string) =>
  new RegExp(
    /^[a-zA-Z]{3,}(-[a-zA-Z]{3,})?-[a-zA-Z]{3,}-[2-9][0-9]{3}[0-1][0-9][0-3][0-9]-[0-9]{3,}(-[0-9]{3,})?$/,
  ).test(str);

export const sanitizeNonAlphaChars = (str: string) => {
  return str.replace(/[^a-zA-Z0-9]/g, '');
};

export const isProductId = (str: string): boolean => {
  return new RegExp(/^PTP-\d{9}$/).test(str);
};
